jQuery( function ($) {

    if ( typeof gform == 'object' ) {
    
        // improved gform ajax spinner
        $(document).on( 'submit', '.gform_wrapper form', function () {
            let $button = $( 'button[type=submit]', this );
            if ( !$button.length ) { return; }
            $button.attr( 'disabled', true );
            $button.attr( 'aria-disabled', 'true' );
            $button.addClass( 'is-ajax-submitting' );
        });


        $(document).on( 'gform_post_render', function ( e, form_id, current_page ) {
            $( 'select', `#gform_${ form_id }` ).each( function () {
                ThemeJS.Functions.init_select2( this );
            });
            nest_gform_fields( form_id );
            set_unit_widths( form_id );
            init_ranges( form_id );
            move_fsa_errors( form_id );
            observe_size( form_id );
            move_error_summary( form_id );
            improve_send_resume_link_btn( form_id );
        });


        window.addEventListener( "message", event => {
            const match = /gform_paged_(\d+)/.exec( event.data );
            if ( match ) {
                ThemeJS.Functions.scroll_to( $(`#gform_wrapper_${ match[1] }`), {
                    direction: 'up',
                    offset: 30,
                });
            }
        }, false );


        // overwrite default gforms function because we've edited the markup and it breaks the .parent chain
        window.gformToggleRadioOther = function ( radioElement ) {
            // var $other = radioElement.parentElement.parentElement.parentElement.lastChild.querySelector( 'input[type="text"]' );
            const $other = $(radioElement).closest( '.gfield_radio' ).children().last().find( 'input[type="text"]' ).get(0);
            if ( $other ) {
                $other.disabled = radioElement.value !== 'gf_other_choice';
            }
        
        }


        // #region uploads
        const file_icon_types = {
            'csv': [ 'csv' ],
            'pdf': [ 'pdf' ],
            'zipper': [ 'zip' ],
            'excel': [ 'xls', 'xlsx' ],
            'word': [ 'doc', 'docx' ],
            'image': [ 'png', 'jpg', 'jpeg' ],
        };

        function get_file_fa_class ( ext ) {
            const type = Object.keys( file_icon_types ).reduce( ( type, key ) => {
                return ( !type && file_icon_types[ key ].includes( ext ) ) ? key : type;
            }, null );
            return ['fa', 'file', type ].filter( x => x ).join('-');
        }

        function get_gfile_preview ( file, actions ) {
            const ext = ThemeJS.Functions.get_extension( file.name );
            const display_name = ext ? file.name.substring( 0, file.name.lastIndexOf( '.' ) ) : file.name;
            return `
                <span class='ftype fas ${ get_file_fa_class( ext ) }'></span>
                <div class='details'>
                    <div>${ display_name }</div>
                    <div class='filesize'>${ ThemeJS.Functions.format_bytes( file.size ) }</div>
                </div>
                ${ actions }
            `;
        }

        // file being added, during upload
        gform.addFilter( 'gform_file_upload_status_markup', function ( html, file, size, strings, removeFileJs, up ) {
            const btn = `
                <div class='actions'>
                    <span class="gfield_fileupload_progress">
                        <span class="gfield_fileupload_progressbar">
                            <span class="gfield_fileupload_progressbar_progress"></span>
                        </span>
                        <span class="gfield_fileupload_percent"></span>
                        <div class='cancel'>
                            <button type='button' class='btn btn-link link-danger' onclick="${ removeFileJs }">${ strings.cancel }</button>
                        </div>
                    </span>
                </div>
            `;
            return `<div id='${ file.id }' class='ginput_preview'>${ get_gfile_preview( file, btn ) }</div>`;
        });

        // upload finished
        gform.addFilter('gform_file_upload_markup', function ( html, file, up, strings, imagesUrl, response) {
            const btn = `
                <button type='button' class='actions gform_delete_file btn btn-inverse-outline-danger' onclick='gformDeleteUploadedFile(${ up.settings.multipart_params.form_id }, ${ up.settings.multipart_params.field_id }, this)'>
                    <span class='icon fas fa-trash' aria-hidden='true'></span>
                    <span class='screen-reader-text'>${ strings.delete_file }: ${ file.name }</span>
                </button>
            `;
            return get_gfile_preview( file, btn );
        });
        // #endregion

        // #region gchoice nested fields
        function nest_gform_fields ( form_id ) {
            if( ! window.gf_form_conditional_logic ) {
                return;
            }
            const $form = $( `form#gform_${ form_id }`);
            const conditional_logic = rgars( gf_form_conditional_logic, [ form_id, 'logic' ].join( '/' ) );
            if ( !conditional_logic ) { return; }
            Object.entries( conditional_logic ).forEach( entry => {
                const [ field_id, logic ] = entry;
                if ( logic.field ) {
                    const $dependent_field = $( `#field_${ form_id }_${ field_id }` );
                    if ( $dependent_field.length && $dependent_field.hasClass( 'nest_in_gchoice' ) ) {
                        logic.field.rules.forEach( rule => {
                            const $gchoice_input = $( `#field_${ form_id }_${ rule.fieldId } .gfield-choice-input[value='${ rule.value }']` );
                            if ( $gchoice_input.length ) {
                                $gchoice_input.closest( '.gchoice' ).addClass( 'has-nested-field' ).append( $dependent_field );
                            }
                        });
                    }
                }
            });
        }
        // setTimeout( function () {
        //     $( `form[id^=gform_]` ).each( function () {
        //         const form_id = this.id.replace( 'gform_', '' );
        //         console.log( 'timeout' );
        //         nest_gform_fields( form_id );
        //         set_unit_widths( form_id );
        //         init_ranges( form_id );
        //     });
        // }, 1 );
        // #endregion

        // #region conditional disabling
        // class allows disabling field without hiding it when conditional logic is triggered
        $(document).on( 'gform_pre_conditional_logic', function ( e, form_id, cond_fields, is_init ) {
            toggle_conditional_disabled( form_id, cond_fields, false );
        });


        $(document).on( 'gform_post_conditional_logic', function ( e, form_id, cond_fields, is_init ) {
            if ( is_init ) {
                // gforms adds this class to elements disabled on load and prevents them from being changed by conditional logic
                $( `form#gform_${ form_id } .gfield.cond_disable :input` ).removeClass( 'gf-default-disabled' );
            }
            toggle_conditional_disabled( form_id, cond_fields, true );
        });

        function toggle_conditional_disabled ( form_id, cond_fields, show ) {
            if ( $.isArray( cond_fields ) ) {
                const field_ids = cond_fields.map( field_id => `#field_${ form_id }_${ field_id }` );
                $( field_ids.join(',') ).filter( '.cond_disable[data-conditional-logic=hidden]')[ show ? 'show' : 'hide' ]();
            }
        }
        // #endregion

        // #region xl-btn-radios
        $(document).on( 'click', '.gfield.xl-btn-radios > .ginput_container > .gfield_radio > .gchoice', function ( e ) {
            const $input = $( '> .pseudo-check-wrap > .gfield-choice-input', this );
            if ( !$input.is(':checked') ) {
                $input.prop( 'checked', true ).trigger( 'change' );
            }
            const $target = $( e.target );
            let $focus = null;
            if ( $target.is( 'input, select, textarea' ) ) {
                $focus = $target;
            }
            else if ( $target.is( 'label' ) ) {
                $focus = $( `#${ $target.attr( 'for' ) }` );
            }
            else if ( $target.closest( '.nest_in_gchoice' ).length ) {
                $focus = $( 'input, select, textarea', $target ).first();
            }
            else {
                $focus = $input;
            }
            if ( $focus && $focus.length ) {
                $focus.focus();
            }
        });
        // #endregion

        // #region numbers
        function set_unit_widths ( form_id ) {
            const $form = $( `form#gform_${ form_id }`);
            $( '.unit-label', $form ).each( function () {
                const width = $(this).width();
                $(this).parent().css( '--unit-width', `${ width }px` );
            });
        }
        // #endregion
    
        // #region range-radios
        const grange_observer = new ResizeObserver( entries => {
            for ( let entry of entries ) {
                $( entry.target ).toggleClass( 'range-mode', entry.contentRect.width >= 600 );
            }
        });

        function init_ranges ( form_id ) {
            const $form = $( `form#gform_${ form_id }`);
            $( '.gradio-range', $form )
                .each( function () {
                    match_range_to_radio( this );
                    grange_observer.observe( this );
                })
                .on( 'input', 'input[type=range]', function ( e ) {
                    $( 'input[type=radio]', e.delegateTarget ).prop( 'checked', false ).eq( $(this).val() ).prop( 'checked', true ).trigger( 'change' );
                })
                .on( 'change', 'input[type=radio]', function ( e ) {
                    match_range_to_radio( e.delegateTarget );
                });
        }

        function match_range_to_radio ( gradio_range ) {
            $( 'input[type=range]', gradio_range ).val( $( 'input[type=radio]:checked', gradio_range ).closest('.gchoice').index() );
        }
        // #endregion

        // #region fsa-validation
        function move_fsa_errors ( form_id ) {
            const $form = $( `form#gform_${ form_id }`);
            $( '.fsa-validation-error', $form ).each( function () {
                const $page = $(this).closest( '.gform_page' );
                const $move_to = $page.length ? $( '.gform_page_footer', $page ) : $(this).closest( 'form' ).find( '.gform_footer' );
                $move_to.prepend( $(this) );
            });
        }
        // #endregion
    
        // #region resize-obs
        const gform_observer = new ResizeObserver( entries => {
            for ( let entry of entries ) {
              set_inline_submit_styles( $( entry.target ) );
              $( '.gfield_error', entry.target ).each( set_error_position );
            }
        });
    
        function observe_size ( form_id ) {
            $( `form#gform_${ form_id } .gform_fields` ).each( function () {
                gform_observer.observe( this );
            })
        }

        function set_inline_submit_styles ( $gfields ) {
            const $submit = $( '.gfield--width-fill + .gfield--type-submit', $gfields );
            if ( $submit.length ) {
                const $filled = $submit.prev();
                $filled.addClass( 'btn-inline' );
                $filled.toggleClass( 'btn-inline', ( $submit.get(0).offsetTop == $filled.get(0).offsetTop ) );
            }
        }
    
        function set_error_position () {
            // scoped to .gfield
            $(this).css( '--input-container-top', `${ $( '.ginput_container', this ).get(0).offsetTop }px` );
        }
        // #endregion
    
        // puts error summary inside gform_body -- better for paginated forms
        function move_error_summary ( form_id ) {
            const $wrap = $( `#gform_wrapper_${ form_id }` );
            const $err = $( '.gform_validation_errors', $wrap );
            const $body = $( '.gform_body', $wrap );
            if ( $err.length && $body.length ) {
                $body.prepend( $err );
            }
        }

        // replaces <input name='gform_send_resume_link_button'/> with <button> that has loading elements
        // basically a duplicate of php filter on 'gform_submit_button', but I can't find a good way to filter this button server-side to apply the same function
        function improve_send_resume_link_btn ( form_id ) {
            const $form = $( `form#gform_${ form_id }`);
            $( 'input[name=gform_send_resume_link_button]', $form ).each( function () {
                const $btn = $( '<button>' ).addClass( 'btn btn-inverse-outline-secondary gform_send_resume_link_button' );
                for ( let i = 0; i < this.attributes.length; i++ ) {
                    const attr = this.attributes[ i ];
                    if ( attr.name == 'value' ) {
                        const $label = $( '<span>' ).addClass( 'label' );
                        const $text = $( '<span>' ).addClass( 'btn-text' ).html( attr.value );
                        $label.append( $text );
                        $btn.append( $label );
                    } else {
                        $btn.attr( attr.name, attr.value );
                    }
                }
                const $loading = $( '<span>' ).addClass( 'loading' );
                const $icon = $( '<span>' ).addClass( 'fas fa-cog fa-spin' );
                $loading.append( $icon );
                $btn.append( $loading );
                $(this).replaceWith( $btn );
            });
        }
    }


    $( document ).on( 'select2:open', function ( e ) {
        const $s2_cont = $( e.target ).next( '.select2-container' );
        const $dd_cont = $( '.select2-dropdown' ).closest( '.select2-container' );
        const style = getComputedStyle( $s2_cont.get(0) );
        $dd_cont.css({
            '--pad-l': style.getPropertyValue( '--pl' ),
            '--pad-y': style.getPropertyValue( '--py' ),
            'font-size': style.getPropertyValue( 'font-size' )
        });
    });

});